import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ClientDepartmentItem } from "./ClientDepartmentItem";
import { getClientDepartmentsByAccountPartyIdAsync, resetSelectedRecordObjectInState, DeleteSelectedAccountClientDepartmentAsync, updatePagination } from "./ClientDepartmentSlice";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { useLocation, useNavigate } from "react-router-dom";
import Select, { StylesConfig } from 'react-select';
import CustomPagination from "../../../common/Pagination";
import { getFilteredList, sortData, getValueFromResource } from "../../../common/timeLiveFunction";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import PageSizeSelect from "../../../common/PageSizeSelect";
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

export const ClientDepartment = (props: any) => {
    const { onhandleOnClickEvent, t, AccountPartyId } = props;
    const location = useLocation();
    const dispatch = useAppDispatch();
    const { clientDepartmentList, isReload, selectedRecord, sortOrder, sortColumn, search, pageNo, pageSize } = useAppSelector((state) => state.clientDepartment)
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const { IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const pageId: string = '97';
    const navigate = useNavigate();

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            }
        };
        fetchPagePermissions();
    }, [dispatch, location.pathname, navigate, pageId]);

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (event: any) => {
        const { value } = event;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    // const filteredData: any = getFilteredList(clientDepartmentList, searchTerm);
    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const filteredData: any = getFilteredList(clientDepartmentList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = clientDepartmentList.length;
    const recordsFiltered = currentItems.length;
    const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];

    useEffect(() => {
        if (isReload) {
            dispatch(getClientDepartmentsByAccountPartyIdAsync(AccountPartyId));
        }
    }, [isReload])

    useEffect(() => {
        dispatch(getClientDepartmentsByAccountPartyIdAsync(AccountPartyId));

    }, [dispatch])

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(DeleteSelectedAccountClientDepartmentAsync(clientDepartmentList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Client Contact delete Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    return (
        <>
            <div className="card card-custom  admin-card">
                <div className="card-header sticky-top bg-white" style={{ marginLeft: '-10px' }} >
                    <h3 className="card-title fw-bold mainHeading">
                        {/* {t('Client Department')} */}
                        {getValueFromResource('Client Department',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={colourStyles}
                                options={options}
                                value={options.find(option => parseInt(option.value) == pageSize)}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            /> */}
                            <PageSizeSelect onChange={handlePageSizeChange}/>
                        </div>


                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        {((IsDelete && clientDepartmentList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null
                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: clientDepartmentList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{clientDepartmentList.filter((item: any) => item.isSelected === 1).length}</span>
                                     {/* {t('Selected')} */}
                                     {getValueFromResource('Selected',dispatch, t)}
                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: clientDepartmentList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete',dispatch, t)}
                                </button>
                            </>
                        }
                    </div>
                </div>
                {/* <div className="card-body"> */}
                <div className="card-Report-body">
                    <div className="table-responsive">
                        <ClientDepartmentItem clientDepartmentList={currentItems} AccountPartyId={AccountPartyId} t={t} IsEdit={IsEdit} IsDelete={IsDelete} onhandleOnClickEvent={onhandleOnClickEvent} />
                    </div>
                </div>
            </div>
        </>
    )
}